import { useState } from "react"
import { Link } from "react-router-dom"
import "./MovementActivity.css"
import { formatReadableDate } from "utils/formatDate"

const ITEMS_PER_LOAD = 3

const MovementActivity = ({ data = [] }) => {
  const [visibleCount, setVisibleCount] = useState(ITEMS_PER_LOAD)

  const displayedData = data.slice(0, visibleCount)

  const handleLoadMore = () => {
    setVisibleCount(prev => Math.min(prev + ITEMS_PER_LOAD, data.length))
  }

  const handleShowLess = () => {
    setVisibleCount(prev => Math.max(prev - ITEMS_PER_LOAD, ITEMS_PER_LOAD))
  }

  return (
    <>
      <ul className="activity-timeline list-unstyled mb-0">
        {displayedData.map((event, index) => {
          const isFuel = event?.type === "fuel"
          return (
            <li className="activity-item" key={index}>
              <div
                className={`activity-icon ${
                  isFuel ? "bg-success text-white " : ""
                }`}
                style={
                  isFuel ? { borderColor: "white" } : { borderStyle: "dashed" }
                }
              >
                <i className={`bx bx-map `}></i>
              </div>

              <div
                className={`activity-content position-relative overflow-hidden ${
                  isFuel ? "bg-success border-success" : ""
                }`}
              >
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <h6 className={`mb-0 ${isFuel ? "text-white" : ""}`}>
                    {event.title}
                  </h6>
                  <small className={`${isFuel ? "text-white" : ""}`}>
                    {formatReadableDate(event.date)}
                  </small>
                </div>

                <i
                  className={`bx position-absolute end-0 bottom-0 ${
                    isFuel ? "bx-gas-pump text-white" : "bx-car"
                  }`}
                  style={{ fontSize: "4rem", opacity: 0.1 }}
                ></i>

                {event.details && (
                  <p className={`mb-1 ${isFuel ? "text-white" : ""}`}>
                    {event.details}
                  </p>
                )}

                {event.distance && (
                  <p
                    className={`mb-0 text-primary fw-semibold ${
                      isFuel ? "text-white" : ""
                    }`}
                  >
                    <i className="bx bx-ruler me-1"></i>
                    {event.distance}
                  </p>
                )}

                {event.link && (
                  <Link
                    className={`${isFuel ? "text-white" : ""}`}
                    to={event.link}
                  >
                    {event.linkText ?? "View Details"}
                  </Link>
                )}
              </div>
            </li>
          )
        })}
      </ul>

      <div className="d-flex gap-2 mt-2">
        {visibleCount > ITEMS_PER_LOAD && (
          <button
            className="btn btn-outline-secondary"
            onClick={handleShowLess}
          >
            Show Less ({visibleCount - ITEMS_PER_LOAD} of {data.length})
          </button>
        )}

        {visibleCount < data.length && (
          <button className="btn btn-outline-primary" onClick={handleLoadMore}>
            Load More ({Math.min(visibleCount + ITEMS_PER_LOAD, data.length)} of{" "}
            {data.length})
          </button>
        )}
      </div>
    </>
  )
}

export default MovementActivity
